import React from "react";
import { Button } from "antd";
import { formatDate } from "../../../../utility/commonConstant";

export const getBundlesColumns = (onViewDetails) => [
  {
    title: "Title",
    dataIndex: "bundleName",
    key: "bundleName",
    align: "left",
    width: 350,
    onCell: () => ({ className: "text-left pl-12" }),
    render: (bundleName) => <div>{bundleName}</div>,
  },
  {
    title: "Courses",
    dataIndex: "courseCount",
    key: "courseCount",
    align: "center",
    width: 350,
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    align: "center",
    width:300,
    render: (date) => formatDate(date, "DD-MMM-YYYY"),
  },
  {
    title: <div className="text-left">Action</div>,
    key: "action",
    align: "right",
    width: 50,
    onCell: () => ({ className: "text-right pr-12" }),
    render: (_, record) => (
      <Button
        type="link"
        className="!text-[rgba(145,14,17,1)] underline !p-0 text-left"
        onClick={() => onViewDetails(record.bundleId, record.bundleName)}
      >
        View Details
      </Button>
    ),
  },
];